var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueFeedback',{attrs:{"type":"error"}},[_c('template',{slot:"feedback-title"},[_vm._v(_vm._s(_vm.$t('title')))]),_c('template',{slot:"feedback-content"},[_c('p',{staticClass:"complaints-feedback__text",domProps:{"innerHTML":_vm._s(_vm.$t('description'))}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }